module.exports = __webpack_public_path__ + "img/H6951.670b30c1.png";